// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2y2O7","content":"styles_content__uUjkC","tableWrap":"styles_tableWrap__3hUav"};